import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ModalUbicaciones } from "./ModalUbicacionesPorEmpresa";
import { useEmpresaLocations } from "@/hooks/useEmpresaLocations";

export const Carrusel = ({ list }) => {
  const { show, setShow, empresaId, listaComunas, setListaComunas, handleClick } =
    useEmpresaLocations();

  const SampleNextArrow = (props)  => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", background: "#80808061", borderRadius:"50%" }}
        onClick={onClick}
      />
    );
  }
  
  const SamplePrevArrow = (props)  => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", background: "#80808061" , borderRadius:"50%"}}
        onClick={onClick}
      />
    );
  }
 
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const banners = Array.isArray(list?.data) ? list.data : [];

  return (
    <div className="slider-container">
      <ModalUbicaciones show={show} setShow={setShow} listaComunas={listaComunas}
      setListaComunas={setListaComunas}
      empresaId={empresaId}
      />
      {banners.length > 0 ? (
        <Slider {...settings}>
          {banners.map((item) => (
            <div
              key={item.banners_id}
              onClick={item.empresa_id ? () => handleClick(item.empresa_id) : undefined}
              style={item.empresa_id ? { cursor: "pointer" } : undefined}
            >
              <img
                className="banner-fit"
                src={item.imagen}
                alt="slider 1"
                width="100%"
                height="100px"
              />
            </div>
          ))}
        </Slider>
      ) : (
        <div className="banner-placeholder" aria-hidden="true" />
      )}
    </div>
  );
};
